var propertyTaxIncrease = function(property) {
  return property * .000207;
};

var salesTax = [
  { income: 0, diff: 186 },
  { income: 14, diff: 220 },
  { income: 26, diff: 277 },
  { income: 35, diff: 333 },
  { income: 45, diff: 376 },
  { income: 61, diff: 419 },
  { income: 75, diff: 484 },
  { income: 93, diff: 563 },
  { income: 118, diff: 706 },
  { income: 153, diff: 977 }
];

var salesTaxIncrease = function(income) {
  income /= 1000;
  if (income == 0) return 0;
  for (var i = salesTax.length - 1; i >= 0; i--) {
    var bracket = salesTax[i];
    if (income > bracket.income) return bracket.diff;
  }
};

var carTabIncrease = function(rta) {
  return rta * .93;
};

var calculatorElement = document.querySelector(".calculator");

var process = function() {

  var formula = {
    property: propertyTaxIncrease,
    sales: salesTaxIncrease,
    car: carTabIncrease
  }

  var total = 0;
  for (var k in formula) {
    var input = calculatorElement.querySelector(`[data-in="${k}"]`);
    var value = input.value.replace(/[$,]/g, "") * 1;
    var increase = formula[k](value);
    total += increase;
    var output = calculatorElement.querySelector(".output." + k);
    output.innerHTML = "$" + increase.toFixed(2);
  }

  calculatorElement.querySelector(".total.output").innerHTML = "$" + total.toFixed(2);

};

process();

calculatorElement.addEventListener("keyup", process);